import "./StaffInfoCardBlock.scss";
import { StaffInfoCardBlockProps } from "/Models/Generated/StaffInfoCardBlockProps";
import { CircularWrapper, Picture } from "/App.Components";
import { createSpreadableBem } from "/Helpers/createBem";

const StaffInfoCardBlock = ({
  heading,
  headOfDepartmentPicture,
  headOfDepartmentName,
  headOfDepartmentTitle,
  items,
}: StaffInfoCardBlockProps) => {
  const bem = createSpreadableBem("staff-info-card-block");
  return (
    <div {...bem("")}>
      {heading && <h2 {...bem("__heading")}>{heading}</h2>}
      <div {...bem("__container")}>
        {(headOfDepartmentPicture || headOfDepartmentName) && (
          <div {...bem("__leader")}>
            {headOfDepartmentPicture && (
              <div {...bem("__leader-image")}>
                <CircularWrapper size="Small">
                  <Picture
                    {...headOfDepartmentPicture}
                    pictureBehaviour="Cover"
                  />
                </CircularWrapper>
              </div>
            )}
            <div {...bem("__leader-text")}>
              {headOfDepartmentName && (
                <p {...bem("__leader-name")}>{headOfDepartmentName}</p>
              )}
              {headOfDepartmentTitle && (
                <p {...bem("__leader-title")}>{headOfDepartmentTitle}</p>
              )}
            </div>
          </div>
        )}
        <div {...bem("__separator")}></div>
        {(items?.length ?? 0) > 0 && (
          <ul {...bem("__staff-list")}>
            {items.map((item, idx) => (
              <li key={idx} {...bem("__staff-item")}>
                <span {...bem("__staff-item-name")}>{item.name}</span>
                <span {...bem("__staff-item-title")}>{item.title}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default StaffInfoCardBlock;
